import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { BsThreeDots } from 'react-icons/bs';
import { AiOutlineEye } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';

const DropdownIcons = ({
  handleEdit,
  handleRead,
  handleDelete,
  idItem
}) => {
  return (
    <>
      {(handleEdit || handleDelete) && (
        <DropdownButton
          as={Dropdown}
          key={idItem}
          id={`dropdown-variants-${idItem}`}
          title={<BsThreeDots />}
          data-testid="dropdown_open"
          menuRole='menu'
        >
          {handleRead && (
            <Dropdown.Item eventKey="1">
              <AiOutlineEye color="white" onClick={handleRead} />
            </Dropdown.Item>
          )}
          {handleEdit && (
            <Dropdown.Item eventKey="2">
              <FiEdit color="white" onClick={handleEdit} />
            </Dropdown.Item>
          )}
          {handleDelete && (
            <Dropdown.Item eventKey="3">
              <RiDeleteBinLine color="white" onClick={handleDelete} data-testid="delete_btn" />
            </Dropdown.Item>
          )}
        </DropdownButton>
      )}
    </>
  );
};

DropdownIcons.propTypes = {
  idItem: PropTypes.number,
  handleEdit: PropTypes.func,
  handleRead: PropTypes.func,
  handleDelete: PropTypes.func
};

export default DropdownIcons;
